import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=4860332a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860332a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4860332a')) {
      api.createRecord('4860332a', component.options)
    } else {
      api.reload('4860332a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=4860332a&scoped=true&", function () {
      api.rerender('4860332a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KDnMqZ6kHvfE/JS/comp/SearchFilterTokens.vue"
export default component.exports